import { render } from "./FrameTable.vue?vue&type=template&id=cd6d4060&scoped=true"
import script from "./FrameTable.vue?vue&type=script&lang=js"
export * from "./FrameTable.vue?vue&type=script&lang=js"

import "./FrameTable.vue?vue&type=style&index=0&id=cd6d4060&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd6d4060"]])

export default __exports__